import { AdminRouter, AdminSidebar } from 'stylemix-vue-admin'
import { messageGroups } from '../plugins/i18n'

const base = 'partner-settings'

AdminRouter.addRoutes([
  {
    name: `${base}.commissions`,
    path: `/${base}/:partner_id/commissions`,
    component: () => import('./Commissions.vue'),
    meta: {
      auth: true,
    },
  },
  {
    name: `partner.commissions`,
    path: `/commissions`,
    component: () => import('./Commissions.vue'),
    meta: {
      auth: true,
    },
  },
  {
    name: `partner.partner-orders`,
    path: `/partner-orders`,
    component: () => import('./Orders.vue'),
    meta: {
      auth: true,
    },
  },
  {
    name: `partner.widget`,
    path: `/widget`,
    component: () => import('../widget/Widget.vue'),
    props: {
      defaults: {
        showArrivalBooking: true,
        blank: false,
        hideRideTypes: ['transfer', 'delivery'],
      },
    },
    meta: {
      auth: true,
    },
  },
])

AdminSidebar.pushItem({
  id: `${base}`,
  order: 90,
  header: $vm => $vm.$t(`partners.settings.menu_partner_settings`),
  text: $vm => $vm.$t(`partners.settings.menu_partner_settings`),
  icon: 'icon-cog',
  permission: $vm => {
    return ($vm.$account && $vm.$account.partner) || ($vm.$account && $vm.$account.company)
  },
  children: [
    {
      id: 'partner-settings.partner.commissions',
      order: 30,
      text: $vm => $vm.$t(`partners.settings.commissions_title`),
      route: {
        name: `partner.commissions`,
      },
      icon: 'icon-percent',
    },
    {
      id: 'partner-settings.partner.partner-orders',
      order: 30,
      text: $vm => $vm.$t(`partners.settings.orders_title`),
      route: {
        name: `partner.partner-orders`,
      },
      icon: 'icon-coins',
    },
    {
      id: 'partner-settings.widget',
      text: $vm => $vm.$t('partners.settings.widget_title'),
      icon: 'icon-airplane2',
      route: {
        name: 'partner.widget',
      },
    },
  ],
})

messageGroups.push('partners')
